import { render, staticRenderFns } from "./Ranks.vue?vue&type=template&id=49dd8994"
import script from "./Ranks.vue?vue&type=script&lang=js"
export * from "./Ranks.vue?vue&type=script&lang=js"
import style0 from "./Ranks.vue?vue&type=style&index=0&id=49dd8994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports